export default "__VITE_ASSET__CvHU2wOn__"